export const PARTNER_REACH_OUT_TYPES = {
  NETWORK_REQUEST: 'NETWORK_REQUEST',
};

export const REACH_OUT_STATUSES = {
  SIMPLR_SUBMITTED: 'SIMPLR_SUBMITTED',
  PARTNER_RESPONDED: 'PARTNER_RESPONDED',
  SIMPLR_AGENT_ACTIONED: 'SIMPLR_AGENT_ACTIONED',
  TIMEOUT: 'TIMEOUT',
  ERROR: 'ERROR',
};
